import i18n from "../../../i18n";
const { t } = i18n;

export const types = [
    {
        name: t('sideBar.live'),
        key: "2"
    },
    {
        name: t('sideBar.playback'),
        key: "3"
    }
]

export const motionDetectionLevel = {
    illuminationDefault: [
        {
            label: 'Cao',
            value: 100,
        },
        {
            label: 'Trung bình',
            value: 85,
        },
        {
            label: 'Thấp',
            value: 70,
        },
    ],
    sensitiveDefault: [
        {
            label: 'Cao',
            value: 15,
        },
        {
            label: 'Trung bình',
            value: 10,
        },
        {
            label: 'Thấp',
            value: 5,
        },
    ],
    minObjectSizeDefault: [
        {
            label: 'nhỏ',
            value: 0.3,
        },
        {
            label: 'Trung bình',
            value: 0.5,
        },
        {
            label: 'lớn',
            value: 0.7,
        },
    ],
    maxDisappearDefault: [
        {
            label: 'Cao',
            value: 4,
        },
        {
            label: 'Trung bình',
            value: 3,
        },
        {
            label: 'Thấp',
            value: 2,
        },
    ],
    minDurationDefault: [
        {
            label: 'Cao',
            value: 2,
        },
        {
            label: 'Trung bình',
            value: 1.5,
        },
        {
            label: 'Thấp vừa',
            value: 1.2,
        },
        {
            label: 'Thấp',
            value: 1,
        },
    ]
}
export const commonDetectionLevel = {
    confidenceDefault: [
        {
            label: 'Cao',
            value: 0.6,
        },
        {
            label: 'Trung bình',
            value: 0.7,
        },
        {
            label: 'Thấp',
            value: 0.8,
        },
    ],
    maxDisappearDefault: [
        {
            label: 'Cao',
            value: 4,
        },
        {
            label: 'Trung bình',
            value: 3,
        },
        {
            label: 'Thấp',
            value: 2,
        },
    ],
    minDurationDefault: [
        {
            label: 'Cao',
            value: 1.5,
        },
        {
            label: 'Trung bình',
            value: 1.2,
        },
        {
            label: 'Thấp vừa',
            value: 1,
        },
        {
            label: 'Thấp',
            value: 0.75,
        },
    ]
}
export const cameraMoveDetectionLevel = {
    sensitiveDefault: [
        {
            label: 'Cao',
            value: 15,
        },
        {
            label: 'Trung bình',
            value: 10,
        },
        {
            label: 'Thấp',
            value: 5,
        },
    ],
    minObjectSizeDefault: [
        {
            label: 'nhỏ',
            value: 0.3,
        },
        {
            label: 'Trung bình',
            value: 0.5,
        },
        {
            label: 'lớn',
            value: 0.7,
        },
    ],
    maxDisappearDefault: [
        {
            label: 'Cao',
            value: 4,
        },
        {
            label: 'Trung bình',
            value: 3,
        },
        {
            label: 'Thấp',
            value: 2,
        },
    ],
    minDurationDefault: [
        {
            label: 'Cao',
            value: 1.5,
        },
        {
            label: 'Trung bình',
            value: 1.2,
        },
        {
            label: 'Thấp vừa',
            value: 1,
        },
        {
            label: 'Thấp',
            value: 0.75,
        },
    ]
}